import React, { useState, useEffect } from "react";
import api from "../../api/axios"; // ✅ axios centralisé
import { Button, Grid, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const Forecasts = () => {
  const [forecasts, setForecasts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userStartDate, setUserStartDate] = useState("");
  const [userEndDate, setUserEndDate] = useState("");

  // Fetch Forecasts
  useEffect(() => {
    const fetchForecasts = async () => {
      setLoading(true);
      const params = {};
      if (userStartDate) params.start_date = userStartDate;
      if (userEndDate) params.end_date = userEndDate;

      try {
        const response = await api.get("/quickbooks/forecasts/", { params });
        console.log("forecasts: ", response.data.forecasts);
        setForecasts(response.data.forecasts || []);
      } catch (err) {
        setError("Failed to fetch forecasts");
      } finally {
        setLoading(false);
      }
    };
    fetchForecasts();
  }, [userStartDate, userEndDate]);

  const columns = [
    { Header: "Forecast Name", accessor: "name", align: "left" },
    { Header: "Period", accessor: "period", align: "left" },
    { Header: "Projected Revenue", accessor: "revenue", align: "left" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows = forecasts.map((forecast) => ({
    name: forecast.name,
    period: forecast.period,
    revenue: `$${forecast.revenue}`,
    actions: (
      <Button
        variant="outlined"
        color="primary"
        onClick={() => console.log(`Editing forecast: ${forecast.id}`)}
      >
        Edit
      </Button>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={4}>
            <TextField
              label="Start Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={userStartDate}
              onChange={(e) => setUserStartDate(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="End Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={userEndDate}
              onChange={(e) => setUserEndDate(e.target.value)}
            />
          </Grid>
        </Grid>
        <MDBox pt={3}>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <DataTable table={{ columns, rows }} isLoading={loading} noEndBorder />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Forecasts;
